import { render, staticRenderFns } from "./perform-assess.vue?vue&type=template&id=7d392685&scoped=true"
import script from "./perform-assess.vue?vue&type=script&lang=js"
export * from "./perform-assess.vue?vue&type=script&lang=js"
import style0 from "./perform-assess.vue?vue&type=style&index=0&id=7d392685&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d392685",
  null
  
)

export default component.exports